import React from 'react';
import { servicesData } from '../data/servicesData';
import '../styles/components/EnhancedServices.scss';

const EnhancedServices = ({ isHomepage = false, onServiceSelect }) => {
  return (
    <section className={`enhanced-services ${isHomepage ? 'homepage-view' : 'full-view'}`}>
      <div className="container">
        <div className="services-header">
          <h2>Our Core Services</h2>
          <p>Comprehensive solutions tailored to meet your organizational needs</p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div 
              key={service.id}
              className="service-card"
            >
              <div className="card-image">
                <img 
                  src={service.image} 
                  alt={service.title}
                  onError={(e) => {
                    e.target.src = '/images/service-default.jpg';
                  }}
                />
                <div className="image-overlay">
                  <span className="service-abbr">{service.abbreviation}</span>
                </div>
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
              </div>

              <div className="card-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                
                <div className="service-features">
                  {service.features.slice(0, 3).map((feature, index) => (
                    <span key={index} className="feature-tag">#{feature}</span>
                  ))}
                </div>

              </div>
            </div>
          ))}
        </div>

        {isHomepage && (
          <div className="services-cta">
            <p>Ready to transform your organization with our expertise?</p>
            <a href="/services" className="btn btn-primary">View All Services & Projects</a>
          </div>
        )}
      </div>
    </section>
  );
};

export default EnhancedServices;